import { combineReducers } from "redux";
import commonReducer from "../../../../Common/Reducers/commonReducer";
import drivingMarketParamsReducer from "../drivingMarketsParams";
import HighestVolume from "./highestVolume";
export default combineReducers({
    reducersData: HighestVolume,
    commonData: commonReducer,
    paramsData: drivingMarketParamsReducer,
});
